import Image from "next/image";
import { Checkbox } from "@/shared/components/common/Checkbox";
import Flex from "@/shared/components/common/Flex";
import List from "@/shared/components/common/List";
import Typography from "@/shared/components/common/Typography";
import { toggleCheckBoxFilter } from "@/shared/libs/componentUtils";
import { isString } from "@/shared/libs/type-utils";
import PhosphorIcon from "../../common/PhosphorIcon";
import type { CheckboxOption, FilterComponent } from "../filter.types";

const CheckBoxListFilter: FilterComponent<CheckboxOption[]> = ({
  value,
  applyFilter,
  currentValue,
  placeholder,
}) => {
  const currentState = currentValue;

  const handleChange = (checkbox: string, checked: boolean): void => {
    const toggleCheckBox = toggleCheckBoxFilter(
      checkbox,
      checked,
      currentState,
    );

    applyFilter(toggleCheckBox)();
  };

  const isSelected = (state: string | undefined, code: string): boolean => {
    return state?.split(",").includes(code) ?? false;
  };

  return (
    <Flex className="md:flex-col max-md:gap-x-3 md:px-1 gap-y-3 max-md:flex-wrap!">
      <List
        items={value}
        renderItems={({ name, label, icon }) => (
          <Flex
            className="items-center justify-start gap-x-3 max-md:my-2"
            key={name}
          >
            <Flex className="items-center gap-x-2">
              <Checkbox
                className="rounded-[5px]!"
                checked={isSelected(currentState, name)}
                onCheckedChange={(checked) => handleChange(name, !!checked)}
              />

              {icon && (
                <Flex.Item>
                  {isString(icon) ? (
                    <Image
                      src={icon}
                      className="w-7 h-7"
                      width={100}
                      height={100}
                      alt="airline"
                    />
                  ) : (
                    <PhosphorIcon
                      name={icon.name as keyof typeof PhosphorIcon}
                      size={20}
                      className={icon.classNames}
                    />
                  )}
                </Flex.Item>
              )}

              <Typography>{label}</Typography>
            </Flex>
          </Flex>
        )}
      />
    </Flex>
  );
};

export default CheckBoxListFilter;
